/* GemHub Cart Drawer Fix v5 — Works WITH sticky header */
(function() {
  'use strict';

  function fix() {
    // Move cart-drawer element to <body> level so it's not trapped by header's stacking context
    var cartDrawer = document.getElementById('cart_drawer');
    if (cartDrawer && cartDrawer.parentElement !== document.body) {
      document.body.appendChild(cartDrawer);
    }

    // Force cart drawer styles for full viewport
    var cartSnippet = document.getElementById('shopify-snippet-cart');
    if (cartSnippet) {
      cartSnippet.style.setProperty('position', 'fixed', 'important');
      cartSnippet.style.setProperty('top', '0', 'important');
      cartSnippet.style.setProperty('right', '0', 'important');
      cartSnippet.style.setProperty('height', '100vh', 'important');
      cartSnippet.style.setProperty('height', '100dvh', 'important');
      cartSnippet.style.setProperty('z-index', '2147483647', 'important');
    }

    // Fix overlay
    var overlay = document.getElementById('cart_overlay');
    if (overlay) {
      overlay.style.setProperty('position', 'fixed', 'important');
      overlay.style.setProperty('inset', '0', 'important');
      overlay.style.setProperty('z-index', '2147483646', 'important');
    }

    // Fix inner container scroll
    var dc = document.getElementById('Details-cart-drawer-container');
    if (dc) {
      dc.style.setProperty('height', '100%', 'important');
      dc.style.setProperty('max-height', '100vh', 'important');
      dc.style.setProperty('overflow-y', 'auto', 'important');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
  setTimeout(fix, 500);
  window.addEventListener('load', fix);
})();
